import React, { Component } from 'react'
import './index.css'

//Server Firebase
import firebase from '../../server/firebase.js'

//Feather iconografia
import * as Icon from 'react-feather'

// Notification Noty [Biblioteca terceiro]
import Noty from 'noty'


import { Modal, Button } from 'react-bootstrap'

import PaypalExpressBtn from 'react-paypal-express-checkout';

class Login extends Component {

  constructor(props) {
    super(props)
    // Chamada de providers para SuperLogins
    var providerGoogle = new firebase.auth.GoogleAuthProvider()
    var providerFace = new firebase.auth.FacebookAuthProvider()
    var providerGitHub = new firebase.auth.GithubAuthProvider()
    var providerTwitter = new firebase.auth.TwitterAuthProvider()

    // Estados
    this.state = {
      email: '',
      password: '',
      emailforgot: '',
      provGoogl: providerGoogle,
      provFace: providerFace,
      provGitHub: providerGitHub,
      provTwitter: providerTwitter,
      show: false,
      count: 0,
      loading: false
    }


    // Bind utilizado para ter [this] como referencia dentro de cada metodo do Objeto
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.googleLogin = this.googleLogin.bind(this)
    this.faceLogin = this.faceLogin.bind(this)
    this.twitterLogin = this.twitterLogin.bind(this)
    this.githubLogin = this.githubLogin.bind(this)
    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSubmitForgot = this.handleSubmitForgot.bind(this)
    this.getError = this.getError.bind(this)
  }

  getError(code){

    // Errors baseados nas mensagens do firebase

    var message = 'Ocorreu algum erro'

    switch (code) {
      case 'auth/user-not-found':
        message = 'Email nao encontrado'
        break
      case 'auth/wrong-password':
        message = 'Senha invalida'
        break
      case 'auth/network-request-failed':
        message = 'Sem conexao com a Internet'
        break

      default:
        break
    }

    return message
  }

  handleClose() {
    // Sumir com a Modal de 'Esqueci minha senha'
    this.setState({
      show: false
    })
  }

  handleShow() {
    // Aparecer com a modal e colocar o email que tentou login
    this.setState({
      show: true,
      emailforgot: this.state.email
    })
  }

  handleChange(e) {
    // funcao chamada para alterar todos inputs no component
   this.setState({
     [e.target.name]: e.target.value
   })
  }

  faceLogin(e){
    //Login Social do facebook
    e.preventDefault()
    this.socialLogin(this.state.provFace)
  }

  googleLogin(e){
    //Login Social do Google
    e.preventDefault()
    this.socialLogin(this.state.provGoogl)
  }

  twitterLogin(e){
    //Login Social do Google
    e.preventDefault()
    this.socialLogin(this.state.provTwitter)
  }

  githubLogin(e){
    //Login Social do Google
    e.preventDefault()
    this.socialLogin(this.state.provGitHub)
  }

  socialLogin(provider){
    // Chamada do Popup
    var refThis = this
    refThis.setState({
      loading: true
    })
    firebase.auth().signInWithPopup(provider).then(function(){
      new Noty({type: 'success',layout: 'topRight',text: 'Entrou'}).show()
      refThis.props.closeLogin()
      refThis.setState({
        loading: false
      })
    }).catch(function(error) {

      var errorCode = error.code;
      var errorMessage = error.message;

      var email = error.email;

      var credential = error.credential;
      console.log(errorCode)
      console.log(errorMessage)

      if(errorCode == 'auth/account-exists-with-different-credential'){
        new Noty({type: 'error', layout: 'topRight',text: 'Email sendo utilizado'}).show()
      } else {
        new Noty({type: 'error', layout: 'topRight',text: 'Cancelado'}).show()
      }

      refThis.setState({
        loading: false
      })
    });
  }

  handleSubmit(e){
    // Submetendo o formulario de Login
    e.preventDefault()

    // Email e senha no state
    var email = this.state.email
    var password = this.state.password

    // Usado a referencia 'refThis' para poder usar o 'this' dentro do escopo
    // da funcao do login do firebase
    var refThis = this
    var refAuth = firebase.auth()

    refThis.setState({
      loading: true
    })

    refAuth.signInWithEmailAndPassword(email, password).then(function(result){

      // Notificacao de sucesso para o caso de tudo ocorrer bem
      new Noty({type: 'success',layout: 'topRight',text: 'Entrou'}).show()
      refThis.setState({
        loading: false
      })
      refThis.props.closeLogin()

    }).catch(function(error) {

      // Notificacao de erro para o caso de nao ocorrer certo
      // Mensagem pega com o codigo que o firebase retorna
      var message = refThis.getError(error.code)

      refThis.setState({
        count: (refThis.state.count + 1)
      })

      refThis.setState({
        loading: false
      })

      if(refThis.state.count == 3){
        new Noty({type: 'error', layout: 'topRight',text: 'Verifique seu provedor'}).show()
      }

      if(error.code == 'auth/user-not-found'){
        firebase.auth().createUserWithEmailAndPassword(email, password).then(function(result){
          new Noty({type: 'success',layout: 'topRight',text: 'Criado com Sucesso'}).show()
          refThis.props.closeLogin()
          refThis.setState({
            loading: false
          })
        }).catch(function(error) {

          var errorCode = error.code;
          var errorMessage = error.message;
          var message = refThis.getError(error.code)
          refThis.setState({
            loading: false
          })
          new Noty({type: 'error',layout: 'topRight',text: message}).show()

        })
      } else {
        refThis.setState({
          loading: false
        })
        new Noty({type: 'error',layout: 'topRight',text: message}).show()
      }
    });
  }

  handleSubmitForgot(e){
    e.preventDefault()

    // Pego o valor do 'emailforgot' pois ele pode ser modificado do email original
    var email = this.state.emailforgot


    // Usado a referencia 'refThis' para poder usar o 'this' dentro do escopo
    // da funcao do login do firebase
    var refThis = this
    var refAuth = firebase.auth()

    refAuth.sendPasswordResetEmail(email).then(function() {

      // Notificacao de sucesso para o caso de tudo ocorrer bem
      new Noty({type: 'success',layout: 'topRight',text: 'Email Enviado'}).show()
      // Fechamamento da Modal no caso
      refThis.handleClose()

    }).catch(function(error) {

      // Notificacao de erro para o caso de nao ocorrer certo
      // Mensagem pega com o codigo que o firebase retorna
      var message = refThis.getError(error.code)
      new Noty({type: 'error',layout: 'topRight',text: message}).show()
    })
  }


  render() {

    const {email, password, emailforgot, show, loading} = this.state

    var classLogin = ''



    if(loading){
      classLogin = 'loading visible'
    }else {
      classLogin = 'loading'
    }

    const client = {
  			sandbox:    'ARNJ8_QZ_CcbpUSFiaRhztedeX8UoDNz4t9tFPaPSjaPRCJeJbgFqtwVKQ5irEdq-sVMPzkXG1irbJ_S',
  			production: 'AQdSqpq6O2aTAacPksJMg_7fHp9ocGhniqKJpi-4xAoa61IkAu9pwiMd2lahM4Vg5_QmkJ7ElxOnYsCj',
  		}

    return (
      <div className="Login Container-Single Container-Login">
        <a href="http://mouselabs.com.br"><div className="Back-Button Description"><Icon.ChevronLeft className="Center" color="#DBDDE6" size={24}/><div className="description">Voltar para o site</div></div></a>
        <div className="Card Center">
          <div className="Logo-Marca"></div>
          {/* <form className="Form-Login" onSubmit={this.handleSubmit}>
            <div className="Input-Card">
              <div className="Input-Icon"><Icon.User className="Center" color="#DBDDE6" size={16}/></div>
              <input type="email" placeholder="Email" name="email" value={email} onChange={this.handleChange} required/>
            </div>
            <div className="Input-Card">
              <div className="Input-Icon"><Icon.Lock className="Center" color="#DBDDE6" size={16}/></div>
              <input type="password" placeholder="Senha" name="password" value={password} onChange={this.handleChange} required/>
            </div>
            <div className="Buttons-Card">
              <a onClick={this.handleShow}>Esqueceu a senha</a>
              <button className="Button-Submit" type="submit">Login</button>
            </div>
            <p className="Orlogin">or</p>
          </form> */}
          <p className="orlogin">Criar ou Logar conta</p>
          <p className="para">Para acessar a plataforma você precisa entrar com algum dos logins abaixo, fazemos assim para agilizar seu processo e você poder aprender o mais rápido possível.</p>
          <div className="SuperLogin">
            <button onClick={this.googleLogin} className="google">Google+</button>
            <button onClick={this.faceLogin} className="face">Facebook</button>
          </div>
          <div className="SuperLogin SP-2">
            <button onClick={this.twitterLogin} className="twitter">Twitter</button>
            <button onClick={this.githubLogin} className="github">GitHub</button>
          </div>
          <spam>Usamos as redes sociais para facilitar a criação do perfil do usuário e não compartilhamos nada sem sua persmissão</spam>
        </div>
        <div class={classLogin}>
          <div class="col-sm-2">
            <div class="sp sp-wave"></div>
          </div>
        </div>
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header>
            <div className="WTF FlexBetweenHeader">
              <div className="CloseModal" onClick={this.handleClose}>
                <Icon.X/>
              </div>
            </div>
            <Modal.Title>Enviaremos no seu email a redefinição</Modal.Title>
          </Modal.Header>
          <form>
            <Modal.Body>
              <input type="email" placeholder="Email" name="email" value={email} onChange={this.handleChange} required/>
            </Modal.Body>
            <Modal.Footer>
              <button type="submit" class="bubbly-button" onClick={this.handleSubmitForgot}>Enviar</button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/index.js